import { Navigate, useRoutes } from 'react-router-dom';
//
import { mainRoutes } from './main';
import { useAuthContext } from 'src/auth/hooks';
import { authRoutes } from './auth';
import { authTHERoutes } from './the-login';
import { authDemoRoutes } from './auth-demo';
import { dashboardRoutes } from './dashboard';
import { componentsRoutes } from './components';
import { studentdashboardRoutes } from './student-dashboard';
import { parentdashboardRoutes } from './parent-dashboard';
import { academicdashboardRoutes } from './academic-dashboard';
import { nonacademicdashboardRoutes } from './non-academic-dashboard';
import { paths } from '../paths';
import { heightstudentdashboardRoutes } from './student-height-dashboard';
import { outsiderdashboardRoutes } from './outsider-dashboard';
import { guestdashboardRoutes } from './guest-dashboard';

// ----------------------------------------------------------------------

export default function Router() {
  const { user } = useAuthContext();

  const getUserRole = () => {
    if (user?.is_admin) return 'admin';
    if (user?.is_academic) return 'academic';
    if (user?.is_non_academic) return 'non_academic';
    if (user?.is_student) return 'student';
    if (user?.is_parent) return 'parent';
    if (user?.is_height_student) return 'height_student';
    if (user?.is_outsider) return 'outsider';
    if (user?.is_guest) return 'guest';

    return null;
  };

  const role = getUserRole();

  const PATH = paths.auth.jwt.login;

  const commonRoutes = [
    // Auth routes
    ...authRoutes,
    ...authDemoRoutes,
    ...authTHERoutes,

    // Main routes
    ...mainRoutes,

    // Components routes
    ...componentsRoutes,

    // No match 404
    { path: '*', element: <Navigate to="/404" replace /> },
  ];

  const roleBasedRoutes = () => {
    switch (role) {
      case 'admin':
        return [
          // SET INDEX PAGE WITH SKIP HOME PAGE
          {
            path: '/',
            element: <Navigate to={PATH} />,
          },

          // Dashboard routes
          ...dashboardRoutes,

          // Common routes
          ...commonRoutes,
        ];

      case 'academic':
        return [
          // SET INDEX PAGE WITH SKIP HOME PAGE
          {
            path: '/',
            element: <Navigate to={PATH} />,
          },

          // Dashboard routes
          ...academicdashboardRoutes,

          // Common routes
          ...commonRoutes,
        ];

      case 'outsider':
        return [
          // SET INDEX PAGE WITH SKIP HOME PAGE
          {
            path: '/',
            element: <Navigate to={PATH} />,
          },
          // Student dashboard routes
          ...outsiderdashboardRoutes,
          // Common routes
          ...commonRoutes,
        ];

      case 'non_academic':
        return [
          // SET INDEX PAGE WITH SKIP HOME PAGE
          {
            path: '/',
            element: <Navigate to={PATH} />,
          },
          // Dashboard routes
          ...nonacademicdashboardRoutes,
          // Common routes
          ...commonRoutes,
        ];

      case 'student':
        return [
          // SET INDEX PAGE WITH SKIP HOME PAGE
          {
            path: '/',
            element: <Navigate to={PATH} />,
          },

          // Student dashboard routes
          ...studentdashboardRoutes,

          // Common routes
          ...commonRoutes,
        ];

      case 'parent':
        return [
          // SET INDEX PAGE WITH SKIP HOME PAGE
          {
            path: '/',
            element: <Navigate to={PATH} />,
          },

          // Parent dashboard routes
          ...parentdashboardRoutes,

          // Common routes
          ...commonRoutes,
        ];

      case 'height_student':
        return [
          // SET INDEX PAGE WITH SKIP HOME PAGE
          {
            path: '/',
            element: <Navigate to={PATH} />,
          },

          // Student dashboard routes
          ...heightstudentdashboardRoutes,

          // Common routes
          ...commonRoutes,

        ];

      case 'guest':
        return [
          {
            path: '/',
            element: <Navigate to={paths.guestdashboard.root} replace />,
          },
          ...guestdashboardRoutes,
          ...commonRoutes,
        ];

      default:
        return [
          // SET INDEX PAGE WITH SKIP HOME PAGE
          {
            path: '/',
            element: <Navigate to={PATH} />,
          },

          // Common routes
          ...commonRoutes,
        ];
    }
  };

  // Call useRoutes unconditionally with the role-based routes
  const routes = useRoutes(roleBasedRoutes());

  return routes;
}
